import { useEffect } from 'react';
import { IconClose } from '../../components/icons';

/* The phone's preview: a sheet that rises from the bottom rather than a centred
   dialog, so the send actions sit under the thumb. Stays mounted while closed so
   the transition has something to animate. */
export default function PreviewSheet({ open, onClose, title = 'Preview', footer, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    /* the page behind must not scroll while the sheet is up */
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  return (
    <div
      className={`sheet-wrap ${open ? 'open' : ''}`}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title}>
        <div className="sh">
          <h3>{title}</h3>
          <button className="sheet-x" onClick={onClose} aria-label="Close preview">
            <IconClose />
          </button>
        </div>
        <div className="sheet-body">{children}</div>
        {footer && <div className="sf">{footer}</div>}
      </div>
    </div>
  );
}
